/** Person or company in the questionnaire, the alert type of a field depends on it */
export enum CountryRiskRole {
  Client = 'Client',
  ClientRepresentative = 'ClientRepresentative',
  LegalClient = 'LegalClient',
  LegalClientRepresentative = 'LegalClientRepresentative',
  LegalClientHead = 'LegalClientHead',
  LegalClientLegalHead = 'LegalClientLegalHead',
  LegalClientFirstHead = 'LegalClientFirstHead',
  LegalClientBeneficiary = 'LegalClientBeneficiary',
}

export enum CountryRiskField {
  Citizenship = 'Citizenship',
  TaxResidence = 'TaxResidence',
  PlaceOfBirth = 'PlaceOfBirth',
  ResidentialAddress = 'ResidentialAddress',
  RegistrationAddress = 'RegistrationAddress',
  IdentityDocument = 'IdentityDocument',
  WithdrawalAccountBankCountry = 'WithdrawalAccountBankCountry',
  CompanyTaxResidence = 'CompanyTaxResidence',
  CompanyRegistrationPlace = 'CompanyRegistrationPlace',
  CompanyLegalAddress = 'CompanyLegalAddress',
  CompanyActualAddress = 'CompanyActualAddress',
}

export enum CountryAlertType {
  HardStop = 'HardStop',
  ComplianceReview = 'ComplianceReview',
}

/** Props of the card sections that show country badges */
export interface CountryRiskSectionsProps {
  /** Creation moment of the shown questionnaire version, empty for the current card */
  countryRiskAt?: Date;
}
